// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2fc6G","content":"_35eO1","label":"_2_eWo","timestamp":"_1yYGD","section-name-read-time":"_3MtzL","text":"_1Vydi","author-links":"_1zOzV"};